/**
 * Utilidades para autenticación web con Azure AD
 * Flujo de autorización estándar (no SPA)
 */

/**
 * Genera la URL de autorización de Azure AD
 */
export const generateAuthUrl = (config: {
  clientId: string;
  tenantId: string;
  redirectUri: string;
  authority: string;
  scopes: string[];
}): string => {
  const params = new URLSearchParams({
    client_id: config.clientId,
    response_type: 'code',
    redirect_uri: config.redirectUri,
    scope: config.scopes.join(' '),
    response_mode: 'query',
    state: generateRandomState()
  });

  return `${config.authority}/oauth2/v2.0/authorize?${params.toString()}`;
};

/**
 * Genera un estado aleatorio para seguridad
 */
const generateRandomState = (): string => {
  return Math.random().toString(36).substring(2, 15) + 
         Math.random().toString(36).substring(2, 15);
};

/**
 * Extrae el código de autorización de la URL
 */
export const extractAuthCode = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('code');
};

/**
 * Extrae el estado de la URL
 */
export const extractState = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('state');
};

/**
 * Extrae errores de la URL
 */
export const extractError = (): {
  error: string | null;
  error_description: string | null;
} => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    error: urlParams.get('error'),
    error_description: urlParams.get('error_description')
  };
};

/**
 * Limpia la URL de parámetros de autenticación
 */
export const cleanUrl = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete('code');
  url.searchParams.delete('state');
  url.searchParams.delete('error');
  url.searchParams.delete('error_description');
  window.history.replaceState({}, document.title, url.pathname);
};

